import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=3f5b10fe&scoped=true"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"
import style0 from "./ItemDisplay.vue?vue&type=style&index=0&id=3f5b10fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b10fe",
  null
  
)

export default component.exports